"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioInput = void 0;
var React = require("react");
var RadioInput = /** @class */ (function (_super) {
    __extends(RadioInput, _super);
    function RadioInput(props) {
        return _super.call(this, props) || this;
    }
    RadioInput.prototype.render = function () {
        var inputClass = this.props.showValidationMessage ? "custom-control-input is-invalid" : "custom-control-input";
        return (React.createElement("div", { className: "form-group mt-4 mb-3" },
            React.createElement("label", null, this.props.label),
            React.createElement("div", { className: "input-group width-450 pb-0", role: "group" },
                React.createElement("div", { className: "custom-control custom-radio" },
                    React.createElement("input", { className: inputClass, type: "radio", name: "".concat(this.props.id, "Yes"), id: "".concat(this.props.id, "Yes"), value: this.props.valueTrue, checked: this.props.selectedValue === this.props.valueTrue, onChange: this.props.onChange }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "".concat(this.props.id, "Yes") }, "Yes")),
                React.createElement("div", { className: "custom-control custom-radio" },
                    React.createElement("input", { className: inputClass, type: "radio", name: "".concat(this.props.id, "No"), id: "".concat(this.props.id, "No"), value: this.props.valueFalse, checked: this.props.selectedValue === this.props.valueFalse, onChange: this.props.onChange }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "".concat(this.props.id, "No") }, "No"))),
            this.props.showValidationMessage &&
                React.createElement("div", { className: "text-danger fs-14 font-weight-medium mt-2 mt-md-0 form-group" }, "Please answer this to carry on")));
    };
    return RadioInput;
}(React.Component));
exports.RadioInput = RadioInput;
//# sourceMappingURL=RadioInput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/RadioInput.js
// module id = 1382
// module chunks = 0